export const emailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const grades = [
  { value: '-1', text: 'Pre-K' },
  { value: '0', text: 'Kindergarten' },
  { value: '1', text: 'Grade 1' },
  { value: '2', text: 'Grade 2' },
  { value: '3', text: 'Grade 3' },
  { value: '4', text: 'Grade 4' },
  { value: '5', text: 'Grade 5' },
  { value: '6', text: 'Grade 6' },
  { value: '7', text: 'Grade 7' },
  { value: '8', text: 'Grade 8' },
  { value: '9', text: 'Grade 9' },
  { value: '10', text: 'Grade 10' },
  { value: '11', text: 'Grade 11' },
  { value: '12', text: 'Grade 12' }
]

export const planbookColors = ['#C7561E', '#B5515D', '#C244AB', '#603F99', '#536CA6', '#3640AD', '#3C995B', '#5CA632', '#7EC225', '#A7B828',
  '#CF9911', '#D47F1E', '#B56414', '#914D14', '#AB2671', '#9643A5', '#4585A3', '#737373', '#41A587', '#D1BC36',
  '#AD2D2D', '#D96666', '#E67399', '#B373B3', '#8C66D9', '#668CB3', '#668CD9', '#59BFB3', '#65AD89', '#4CB052',
  '#8CBF40', '#BFBF4D', '#E0C240', '#F2A640', '#E6804D', '#BE9494', '#A992A9', '#8997A5', '#94A2BE', '#85AAA5', '#A7A77D', '#C4A883',
  '#993300', '#333300', '#003300', '#003366', '#000080', '#333399', '#333333', '#800000', '#FF6600',
  '#808000', '#008000', '#008080', '#0000FF', '#666699', '#808080', '#FE090A', '#FE9C0A', '#9CCD0A', '#3A9C6C',
  '#33CCCC', '#3366FF', '#800080', '#999999', '#FF00FF', '#FFCC00', '#FFFF00', '#00FF00', '#00FFFF', '#00CCFF',
  '#993366', '#C0C0C0', '#FF99CC', '#FFCC99', '#FFFF99', '#CCFFCC', '#CCFFFF', '#99CCFF', '#CC99FF', '#FFFFFF', '#000000']

export const newPlanbookColors = [
  '#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3', '#ffffff',
  '#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff', '#ff00ff',
  '#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#c9daf8', '#cfe2f3', '#d9d2e9', '#ead1dc',
  '#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd',
  '#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0',
  '#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79',
  '#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75', '#741b47',
  '#5b0f00', '#660000', '#783f04', '#7f6000', '#274e13', '#0c343d', '#1c4587', '#073763', '#20124d', '#4c1130'
];

export const swatches = [
  ['#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff', '#ff00ff', '#000000', '#cccccc'],
  ['#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd', '#434343', '#d9d9d9'],
  ['#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0', '#666666', '#efefef'],
  ['#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79', '#999999', '#f3f3f3'],
  ['#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75', '#741b47', '#b7b7b7', '#ffffff']
]

export const sections = ['lesson', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'sharedStandards', 'myStandards', 'strategies', 'schoolStandards', 'attachments']

export const planbookFonts = [
  'none',
  'andale mono,times',
  'arial,helvetica,sans-serif',
  'arial black,avant garde',
  'book antiqua,palatino',
  'comic sans ms,sans-serif',
  'courier new,courier',
  'georgia,palatino',
  'helvetica, arial, sans-serif',
  'impact,chicago',
  'tahoma,arial,helvetica,sans-serif',
  'terminal,monaco',
  'times new roman,times',
  'trebuchet ms,geneva',
  'verdana,geneva'
]

export const collaborateSelectItems = [
  { text: 'None - Do not allow collaboration for this class', value: '0' },
  { text: 'View/Import - Allow teachers to view/import, but NOT edit, my lessons', value: '1' },
  { text: 'View/Edit - Allow teachers to view AND edit my lessons', value: '2' },
  { text: 'Replica - This class will show lessons from another class', value: '3' }
]

export const exportTypes = [
  { text: 'Send to PDF Document', value: 'pdf' },
  { text: 'Send to Microsoft Word', value: 'word' },
  { text: 'Send to Google Docs', value: 'drive' }
]

export const printViews = [
  { text: 'Week', value: 'Week' },
  { text: 'Day', value: 'Day' },
  { text: 'Class (List)', value: 'Class' },
  { text: 'Class (Month)', value: 'ClassMonth' },
  { text: 'Events (List)', value: 'Event' },
  { text: 'Events (Month)', value: 'EventMonth' },
  { text: 'Lesson Bank (List)', value: 'LessonBank' },
  { text: 'Notes', value: 'Notes' },
  { text: 'To Do', value: 'ToDo' },
  { text: 'Comments', value: 'Comments' }
]

export const printItems = [
  { value: 'printLessons', section: 'lesson' },
  { value: 'printHomework', section: 'tab2' },
  { value: 'printNotes', section: 'tab3' },
  { value: 'printTab4', section: 'tab4' },
  { value: 'printTab5', section: 'tab5' },
  { value: 'printTab6', section: 'tab6' },
  { value: 'printMyList', section: 'myStandards' },
  { value: 'printSchoolList', section: 'schoolStandards' },
  { value: 'printStrategies', section: 'strategies' },
  { value: 'printStanId', text: 'Standard ID' },
  { value: 'printStanText', text: 'Standard Desc' },
  { value: 'printAttachments', text: 'Attachments' },
  { value: 'printAssignments', text: 'Assignments' },
  { value: 'printAssessments', text: 'Assessments' },
  { value: 'printTimes', text: 'Times' },
  { value: 'printEvents', text: 'Events' },
  { value: 'printEmbeddedImages', text: 'Embedded Images' },
  { value: 'printStatus', text: 'Status' },
  { value: 'printStatusLabel', text: 'Status Label' }
]

export const printToDoItems = [
  { text: 'Done', value: '0', checkedName: 'printToDoDone', checkedValue: 'Y' },
  { text: 'Not Done', value: '1', checkedName: 'printToDoNotDone', checkedValue: 'Y' },
  { text: 'None', value: '2', checkedName: 'printToDoLevel', checkedValue: '0' },
  { text: 'Low', value: '3', checkedName: 'printToDoLevel', checkedValue: '1' },
  { text: 'Medium', value: '4', checkedName: 'printToDoLevel', checkedValue: '2' },
  { text: 'High', value: '5', checkedName: 'printToDoLevel', checkedValue: '3' }
]

export const viewItems = [
  'lesson',
  'tab2',
  'tab3',
  'tab4',
  'tab5',
  'tab6',
  'standardsId',
  'standardsDesc',
  'templates',
  'times',
  'events',
  'action',
  'attachments',
  'assignments',
  'assessments',
  'lessonTitle',
  'unitId',
  'strategies',
  'unitTitle',
  'unitDetails',
  'linkedLessonDetails',
  'sectionTags',
  'linkedUnitTitle',
  'linkedUnitId',
  'linkedUnitDetails',
  'linkedLessonTitle'
]

export const selectViewItems = [
  { text: 'Unit ID', value: 'unitId' },
  { text: 'Unit Title', value: 'unitTitle' },
  { text: 'Unit Details', value: 'unitDetails' },
  { text: 'Linked Unit ID', value: 'linkedUnitId' },
  { text: 'Linked Unit Title', value: 'linkedUnitTitle' },
  { text: 'Linked Unit Details', value: 'linkedUnitDetails' },
  { text: 'Linked Lesson Title', value: 'linkedLessonTitle' },
  { text: 'Linked Lesson Details', value: 'linkedLessonDetails' },
  { text: 'Lesson Title', value: 'lessonTitle' },
  { text: 'Lesson', value: 'lesson' },
  { text: 'Homework', value: 'tab2' },
  { text: 'Notes', value: 'tab3' },
  { text: 'Tab 4', value: 'tab4' },
  { text: 'Tab 5', value: 'tab5' },
  { text: 'Tab 6', value: 'tab6' },
  { text: 'Strategies', value: 'strategies' },
  { text: 'Standard ID', value: 'standardsId' },
  { text: 'Standard Desc', value: 'standardsDesc' },
  { text: 'Attachments', value: 'attachments' },
  { text: 'Assignments', value: 'assignments' },
  { text: 'Assessments', value: 'assessments' },
  { text: 'Templates', value: 'templates' },
  { text: 'Times', value: 'times' },
  { text: 'Events', value: 'events' },
  { text: 'Actions', value: 'action' },
  { text: 'Section Tags', value: 'sectionTags' }
]

export const permissionsMapping: any = {
  lessonTitle: 'permissions11',
  lesson: 'permissions1',
  tab2: 'permissions2',
  tab3: 'permissions3',
  tab4: 'permissions4',
  tab5: 'permissions5',
  tab6: 'permissions6',
  strategies: 'permissions7',
  myStandards: 'permissions8',
  sharedStandards: 'permissions9',
  schoolStandards: 'permissions10',
  attachments: 'permissions12'
}

export const occurrences = [
  { text: 'Repeat Daily', value: 'daily' },
  { text: 'Repeat Weekly', value: 'weekly' },
  { text: 'Repeat BiWeekly', value: 'biweekly' }
]

export const fonts = [
  { value: '1', text: 'Andale Mono' },
  { value: '2', text: 'Arial' },
  { value: '3', text: 'Arial Black' },
  { value: '4', text: 'Book Antiqua' },
  { value: '5', text: 'Comic Sans MS' },
  { value: '6', text: 'Courier New' },
  { value: '7', text: 'Georgia' },
  { value: '8', text: 'Helvetica' },
  { value: '9', text: 'Impact' },
  { value: '10', text: 'Tahoma' },
  { value: '11', text: 'Terminal' },
  { value: '12', text: 'Times New Roman' },
  { value: '13', text: 'Trebuchet MS' },
  { value: '14', text: 'Verdana' }
]

export const fontsText = [
  'Andale Mono',
  'Arial',
  'Arial Black',
  'Book Antiqua',
  'Comic Sans MS',
  'Courier New',
  'Georgia',
  'Helvetica',
  'Impact',
  'Tahoma',
  'Terminal',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana'
]

export const fontSizes = [
  { value: '8', text: '8pt' },
  { value: '9', text: '9pt' },
  { value: '10', text: '10pt' },
  { value: '11', text: '11pt' },
  { value: '12', text: '12pt' },
  { value: '13', text: '13pt' },
  { value: '14', text: '14pt' }
]

export const fontSizesText = [
  '8pt',
  '9pt',
  '10pt',
  '11pt',
  '12pt',
  '13pt',
  '14pt'
]

export const accountTypes = [
  { text: 'Teacher', value: 'T' },
  { text: 'Administrator', value: 'A' },
  { text: 'Teacher and Administrator (Dual Account)', value: 'B' },
  { text: 'District Administrator', value: 'D' }
]

export const E_NOTIFICATIONS = [
  'sendEmail',
  'sendEmail2',
  'sendEmail3',
  'sendEmail4',
  'sendEmail5',
  'sendEmail6'
]

export const SUBSCRIPTIONS = [
  'US $15.00 for one year',
  'US $27.00 for two years ($13.50/year)',
  'US $36.00 for three years ($12.00/year)'
]

export const SUBSCRIPTION_AMOUNTS = [
  15.00,
  27.00,
  36.00
]

export const CHECK_SUBSCRIPTION = [
  'updateLesson',
  'bumpLesson',
  'extendStandards',
  'extendLesson',
  'deleteLesson',
  'removeClassDay',
  'moveLesson',
  'services/planbook/lesson/doLink',
  'services/planbook/lesson/doUnlink',
  'addClass',
  'updateClass/v10',
  'deleteClass',
  'addEvent',
  'updateEvent/v5',
  'deleteEvent',
  'updateToDo',
  'services/planbook/newNote/add',
  'services/planbook/newNote/deleteNote',
  'updateUnit'
]

export const userModeList = [
  {
    text: 'School',
    value: 'adminModeButton'
  },
  {
    text: 'Teacher',
    value: 'teachModeButton'
  }
]

export const accountItems = [
  {
    icon: 'fal fa-user',
    text: 'Account',
    color: 'primary'
  },
  {
    icon: 'fal fa-rocket',
    text: 'Overview',
    color: 'primary'
  },
  {
    icon: 'fab fa-youtube-square',
    text: 'Tutorials',
    color: 'primary'
  },
  {
    icon: 'fal fa-at',
    text: 'Contact Us',
    color: 'primary'
  },
  {
    icon: 'fal fa-comments',
    text: 'Chat Us',
    color: 'primary'
  },
  {
    icon: 'fal fa-info-circle',
    text: 'Knowledge Base',
    color: 'primary'
  },
  {
    icon: 'fal fa-lightbulb-on',
    text: 'Feedback',
    color: 'primary'
  },
  {
    icon: 'fal fa-sync',
    text: 'Refresh',
    color: 'primary'
  },
  {
    icon: 'fal fa-sign-out',
    text: 'Sign Out',
    color: 'primary'
  }
]

export const addItems = [
  {
    icon: 'fal fa-clipboard-list-check',
    text: 'Assessment',
    color: 'primary'
  },
  {
    icon: 'fal fa-pencil-alt',
    text: 'Assignment',
    color: 'primary'
  },
  {
    icon: 'fal fa-palette',
    text: 'Class',
    color: 'primary'
  },
  {
    icon: 'fal fa-calendar-alt',
    text: 'Event',
    color: 'primary'
  },
  {
    icon: 'fal fa-window-maximize',
    text: 'Extra Lesson',
    color: 'primary'
  },
  {
    icon: 'fal fa-calendar-times',
    text: 'No School Day',
    color: 'primary'
  },
  {
    icon: 'fal fa-school',
    text: 'School Year',
    color: 'primary'
  },
  {
    icon: 'fal fa-bullhorn',
    text: 'School Announcements',
    color: 'primary'
  },
  {
    icon: 'fal fa-sticky-note',
    text: 'Substitute Notes',
    color: 'primary'
  },
  {
    icon: 'fal fa-shapes',
    text: 'Template',
    color: 'primary'
  },
  {
    icon: 'fal fa-puzzle-piece',
    text: 'Unit',
    color: 'primary'
  },
  {
    icon: 'fal fa-child',
    text: 'Attendance',
    color: 'primary'
  },
  {
    icon: 'fal fa-chair',
    text: 'Class Seating',
    color: 'primary'
  }
]

export const gotoItems = [
  {
    icon: 'mdi-view-dashboard-outline',
    text: 'Plans',
    color: 'primary'
  },
  {
    icon: 'fal fa-clipboard-list-check',
    text: 'Assessments',
    color: 'primary'
  },
  {
    icon: 'fal fa-pencil-alt',
    text: 'Assignments',
    color: 'primary'
  },
  {
    icon: 'fal fa-child',
    text: 'Attendance',
    color: 'primary'
  },
  {
    icon: 'fal fa-palette',
    text: 'Classes',
    color: 'primary',
    action: 'click',
    selector: '#classNavButton'
  },
  {
    icon: 'fal fa-tv',
    text: 'Display Settings',
    color: 'primary',
    action: 'click',
    selector: '#displayButton'
  },
  {
    icon: 'fal fa-calendar-alt',
    text: 'Events',
    color: 'primary'
  },
  {
    icon: 'fal fa-bullhorn',
    text: 'Grades',
    color: 'primary'
  },
  {
    icon: 'fal fa-cabinet-filing',
    text: 'Lesson Banks',
    color: 'primary'
  },
  {
    icon: 'fal fa-folders',
    text: 'My Files',
    color: 'primary'
  },
  {
    icon: 'fal fa-list-ul',
    text: 'My List',
    color: 'primary'
  },
  {
    icon: 'fal fa-chess-rook-alt',
    text: 'My Strategies',
    color: 'primary'
  },
  {
    icon: 'fal fa-school',
    text: 'School Year',
    color: 'primary'
  },
  {
    icon: 'fal fa-chair',
    text: 'Seating Charts',
    color: 'primary'
  },
  {
    icon: 'fal fa-share-alt',
    text: 'Sharing Options',
    color: 'primary'
  },
  {
    icon: 'fal fa-check-square',
    text: 'Standards Reporting',
    color: 'primary'
  },
  {
    icon: 'fal fa-users',
    text: 'Students',
    color: 'primary'
  },
  {
    icon: 'fal fa-shapes',
    text: 'Templates',
    color: 'primary'
  },
  {
    icon: 'fal fa-puzzle-piece',
    text: 'Units',
    color: 'primary'
  },
  {
    icon: 'fal fa-sign-out',
    text: 'Sign Out',
    color: 'primary'
  }
]

export const sectionTagLabels = {
  lesson: '',
  unit: 'U',
  linkedLesson: 'LL',
  linkedUnit: 'LU'
}

export const seasonalImages = [
  { start: '01-01', end: '01-10', src: 'images/seasonal/welcome-home-jan.png' },
  { start: '02-01', end: '02-15', src: 'images/seasonal/welcome-home-feb.png' },
  { start: '03-10', end: '03-20', src: 'images/seasonal/welcome-home-mar.png' },
  { start: '04-01', end: '04-10', src: 'images/seasonal/welcome-home-apr.png' },
  { start: '04-15', end: '04-25', src: 'images/seasonal/welcome-home-earth.png' },
  // { start: '05-01', end: '05-07', src: 'images/seasonal/welcome-home-taw-world.png' },
  { start: '05-15', end: '05-31', src: 'images/seasonal/welcome-home-may.png' },
  { start: '09-01', end: '09-15', src: 'images/seasonal/welcome-home-sep.png' },
  { start: '10-15', end: '10-31', src: 'images/seasonal/welcome-home-oct.png' },
  { start: '11-15', end: '11-30', src: 'images/seasonal/welcome-home-nov.png' },
  { start: '12-15', end: '12-31', src: 'images/seasonal/welcome-home-dec.png' }
];

export const tawImages = [
  'images/seasonal/welcome-home-taw-grow.png',
  'images/seasonal/welcome-home-taw-rock.png',
  'images/seasonal/welcome-home-taw-heroes.png',
  'images/seasonal/welcome-home-taw-space.png',
  'images/seasonal/welcome-home-taw-thankyou.png'
];
